const locale = {
    'CodePanel.loading': '正在加载代码编辑器...',
    'MiniCode.example': '示例',
    'MiniCode.scanQrcode': '请扫描二维码查看示例程序',
    'DevicePreview.desktop': '电脑',
    'DevicePreview.mobile': '手机',
    'DevicePreview.iphoneProMax': 'iPhone Pro Max',
    'DevicePreview.iphonePro': 'iPhone Pro',
    'DevicePreview.iphoneSE': 'iPhone SE'
};

export default locale;
